"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAccessToObject = void 0;
const channels_1 = require("../types/channels");
const environments_1 = require("../types/environments");
/**
 * Validate environment user access to given object.
 * First validate by document permissions and then by permissionTags.
 *  Currently supported:
 *  - Playlist
 *  - Channel
 * @param obj
 * @param user
 */
const validateAccessToObject = (obj, user, isSystemAdmin) => {
    var _a, _b, _c;
    if (isSystemAdmin) {
        // system admin has always access
        return true;
    }
    const isAdmin = user.role === environments_1.EnvironmentUserRole.admin;
    const { permissionTags } = obj;
    // first check if document permissions
    if (channels_1.isChannel(obj) && ((_a = obj.permissions) === null || _a === void 0 ? void 0 : _a.usePermissions)) {
        // only channels support document permissions at the moment
        if (!(((_b = obj.permissions.user) === null || _b === void 0 ? void 0 : _b.read) || ((_c = obj.permissions.user) === null || _c === void 0 ? void 0 : _c.write))) {
            // user does not have permission to read document if read or write is not true
            return false;
        }
    }
    if (!isAdmin) {
        if (permissionTags) {
            const { permissions } = user;
            if (!permissions) {
                return false;
            }
            if (permissions.tags) {
                const matches = permissions.tags.filter(tag => permissionTags.includes(tag));
                if (matches.length === 0) {
                    return false;
                }
            }
        }
    }
    return true;
};
exports.validateAccessToObject = validateAccessToObject;
//# sourceMappingURL=permissions.js.map